// src/components/Inserir.js
// Tela de INSERÇÃO — formulário para cadastrar novo produto

import React, { useState } from "react";
import { createProduto } from "../services/api";

// Valores iniciais do formulário (facilita o reset)
const FORM_INICIAL = { nome: "", preco: "", estoque: "" };

export default function Inserir({ onVoltar }) {
  // ── Estados ──────────────────────────────────────────────────────
  const [form, setForm]         = useState(FORM_INICIAL); // dados do formulário
  const [loading, setLoading]   = useState(false);         // aguardando API
  const [sucesso, setSucesso]   = useState(null);          // mensagem de sucesso
  const [erros, setErros]       = useState({});            // erros de validação

  // ── Atualiza campo do formulário (handler genérico) ──────────────
  // Usa o atributo "name" do input para saber qual campo atualizar
  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    // Limpa o erro do campo ao digitar
    if (erros[name]) setErros((prev) => ({ ...prev, [name]: "" }));
  }

  // ── Validação do formulário ──────────────────────────────────────
  function validar() {
    const novosErros = {};
    if (!form.nome.trim())
      novosErros.nome = "Nome é obrigatório";
    if (!form.preco || isNaN(form.preco) || Number(form.preco) <= 0)
      novosErros.preco = "Preço deve ser um número positivo";
    if (!form.estoque || isNaN(form.estoque) || Number(form.estoque) < 0 || !Number.isInteger(Number(form.estoque)))
      novosErros.estoque = "Estoque deve ser um número inteiro ≥ 0";
    return novosErros;
  }

  // ── Submissão do formulário ──────────────────────────────────────
  async function handleSubmit(e) {
    e.preventDefault(); // evita reload da página

    // Valida antes de enviar
    const errosValidacao = validar();
    if (Object.keys(errosValidacao).length > 0) {
      setErros(errosValidacao);
      return;
    }

    try {
      setLoading(true);
      setSucesso(null);

      // Monta o objeto produto (conversão de tipos)
      const novoProduto = {
        nome:    form.nome.trim(),
        preco:   parseFloat(form.preco),
        estoque: parseInt(form.estoque, 10),
      };

      const criado = await createProduto(novoProduto);
      setSucesso(`Produto "${criado.nome}" inserido com sucesso! (ID: ${criado.id})`);
      setForm(FORM_INICIAL); // limpa o formulário
      setErros({});
    } catch (e) {
      setErros({ geral: "Erro ao salvar. Verifique se o servidor está rodando." });
    } finally {
      setLoading(false);
    }
  }

  // ── Render ───────────────────────────────────────────────────────
  return (
    <div className="tela">
      <div className="tela-header">
        <h2>➕ Inserir Produto</h2>
        <p>Preencha os dados para cadastrar um novo produto</p>
      </div>

      {sucesso && (
        <div className="status-msg sucesso">
          ✅ {sucesso}
          <button className="btn-fechar-msg" onClick={() => setSucesso(null)}>✕</button>
        </div>
      )}

      {erros.geral && <div className="status-msg erro">❌ {erros.geral}</div>}

      <form onSubmit={handleSubmit} className="formulario" noValidate>
        {/* Campo Nome */}
        <div className="campo">
          <label htmlFor="nome">Nome do Produto *</label>
          <input
            id="nome"
            name="nome"              // ← usado pelo handleChange
            type="text"
            value={form.nome}
            onChange={handleChange}
            placeholder="Ex: Notebook Pro"
            className={erros.nome ? "input-erro" : ""}
          />
          {erros.nome && <span className="msg-erro">{erros.nome}</span>}
        </div>

        {/* Campo Preço */}
        <div className="campo">
          <label htmlFor="preco">Preço (R$) *</label>
          <input
            id="preco"
            name="preco"
            type="number"
            step="0.01"
            min="0"
            value={form.preco}
            onChange={handleChange}
            placeholder="Ex: 1299.90"
            className={erros.preco ? "input-erro" : ""}
          />
          {erros.preco && <span className="msg-erro">{erros.preco}</span>}
        </div>

        {/* Campo Estoque */}
        <div className="campo">
          <label htmlFor="estoque">Estoque (unidades) *</label>
          <input
            id="estoque"
            name="estoque"
            type="number"
            min="0"
            step="1"
            value={form.estoque}
            onChange={handleChange}
            placeholder="Ex: 25"
            className={erros.estoque ? "input-erro" : ""}
          />
          {erros.estoque && <span className="msg-erro">{erros.estoque}</span>}
        </div>

        {/* Botões */}
        <div className="form-acoes">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "⏳ Salvando..." : "💾 Salvar Produto"}
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => setForm(FORM_INICIAL)}>
            🗑 Limpar
          </button>
        </div>
      </form>
    </div>
  );
}
